<div class="agenx-select mb-input"
  [ngClass]="{'agenx-select--error': control.errors && control.touched, 'agenx-select--success': control.valid && control.touched}">
  <select [id]="idInput" class="agenx-select__select" [formControl]="control"  name="select" (change)="returnChange($event)">
    @for (option of options; track option.value) {
    <option class="agenx-select__option" [value]="option.value"> {{ option.label }} </option>
    }
  </select>
  <label [for]="idInput" class="agenx-select__label" [ngClass]="labelClasses"> {{ label }} </label>
</div>
